// extracted by mini-css-extract-plugin
export default {"instantSearchList":"InstantSearchList_instantSearchList__jkVAj"};